const mypass = "1712003"
export default mypass